import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getPaymentPeriod = (state: StateScheme) => {
    return state.payment.period
}
